import { translations } from '../translations'

export function extractMetaNames(
  allowedSubtypes: string[] | undefined
): string {
  if (!allowedSubtypes?.length) return '-'
  const first = allowedSubtypes[0]
  return (translations.subtype[first] as string) ?? first
}
